import React from 'react';
import { Button, useBoolean } from '@odin-labs/components';
import {
  GetScheduleDetailsDocument,
  ScheduleStatus,
} from 'apollo/generated/client-operations';
import { EnvelopeIcon, EnvelopeCircleCheckIcon } from 'components/icons';
import { getPrettyFormattedShortDateTime } from 'utils/dates';
import { ScheduleNotificationsModal } from 'containers/jobsite/tabs/jobsiteSchedules/modals/scheduleNotifications';
import { useJobsiteSchedules } from './jobsiteSchedulesProvider';

export function JobsiteNotificationStatusButton(): React.ReactElement {
  const { selectedSchedule } = useJobsiteSchedules();

  const {
    setFalse: closeModal,
    setTrue: openModal,
    value: isModalOpen,
  } = useBoolean();
  const { notifiedAt, status: scheduleStatus } = selectedSchedule ?? {};

  if (!selectedSchedule) return null;

  if (scheduleStatus !== ScheduleStatus.Completed) {
    return (
      <p className="odin-text-gray-400">
        Notifications can be sent once the schedule is Completed
      </p>
    );
  }

  return (
    <>
      <Button
        icon={notifiedAt ? EnvelopeCircleCheckIcon : EnvelopeIcon}
        onClick={openModal}
        theme={notifiedAt ? 'nakedSafe' : 'nakedWhite'}
        text={
          notifiedAt
            ? `Notified ${getPrettyFormattedShortDateTime(notifiedAt)}`
            : 'Send Notifications'
        }
      />
      <ScheduleNotificationsModal
        isOpen={isModalOpen}
        closeModal={closeModal}
        scheduleId={selectedSchedule?.id}
        refetchQuery={GetScheduleDetailsDocument}
      />
    </>
  );
}
